// Auto-generated by scripts/sync-models-dev.mjs
import alibabaModels from "./providers/alibaba.js";
import alibaba_cnModels from "./providers/alibaba-cn.js";
import amazon_bedrockModels from "./providers/amazon-bedrock.js";
import anthropicModels from "./providers/anthropic.js";
import azureModels from "./providers/azure.js";
import basetenModels from "./providers/baseten.js";
import cerebrasModels from "./providers/cerebras.js";
import chutesModels from "./providers/chutes.js";
import cloudflare_workers_aiModels from "./providers/cloudflare-workers-ai.js";
import deepinfraModels from "./providers/deepinfra.js";
import deepseekModels from "./providers/deepseek.js";
import fastrouterModels from "./providers/fastrouter.js";
import fireworks_aiModels from "./providers/fireworks-ai.js";
import github_copilotModels from "./providers/github-copilot.js";
import github_modelsModels from "./providers/github-models.js";
import googleModels from "./providers/google.js";
import google_vertexModels from "./providers/google-vertex.js";
import google_vertex_anthropicModels from "./providers/google-vertex-anthropic.js";
import groqModels from "./providers/groq.js";
import huggingfaceModels from "./providers/huggingface.js";
import inceptionModels from "./providers/inception.js";
import inferenceModels from "./providers/inference.js";
import llamaModels from "./providers/llama.js";
import lmstudioModels from "./providers/lmstudio.js";
import mistralModels from "./providers/mistral.js";
import modelscopeModels from "./providers/modelscope.js";
import moonshotaiModels from "./providers/moonshotai.js";
import moonshotai_cnModels from "./providers/moonshotai-cn.js";
import morphModels from "./providers/morph.js";
import nvidiaModels from "./providers/nvidia.js";
import openaiModels from "./providers/openai.js";
import opencodeModels from "./providers/opencode.js";
import openrouterModels from "./providers/openrouter.js";
import perplexityModels from "./providers/perplexity.js";
import requestyModels from "./providers/requesty.js";
import submodelModels from "./providers/submodel.js";
import syntheticModels from "./providers/synthetic.js";
import togetheraiModels from "./providers/togetherai.js";
import upstageModels from "./providers/upstage.js";
import v0Models from "./providers/v0.js";
import veniceModels from "./providers/venice.js";
import vercelModels from "./providers/vercel.js";
import wandbModels from "./providers/wandb.js";
import xaiModels from "./providers/xai.js";
import zaiModels from "./providers/zai.js";
import zai_coding_planModels from "./providers/zai-coding-plan.js";
import zhipuaiModels from "./providers/zhipuai.js";
export const providersCatalog = {
    alibaba: alibabaModels,
    "alibaba-cn": alibaba_cnModels,
    "amazon-bedrock": amazon_bedrockModels,
    anthropic: anthropicModels,
    azure: azureModels,
    baseten: basetenModels,
    cerebras: cerebrasModels,
    chutes: chutesModels,
    "cloudflare-workers-ai": cloudflare_workers_aiModels,
    deepinfra: deepinfraModels,
    deepseek: deepseekModels,
    fastrouter: fastrouterModels,
    "fireworks-ai": fireworks_aiModels,
    "github-copilot": github_copilotModels,
    "github-models": github_modelsModels,
    google: googleModels,
    "google-vertex": google_vertexModels,
    "google-vertex-anthropic": google_vertex_anthropicModels,
    groq: groqModels,
    huggingface: huggingfaceModels,
    inception: inceptionModels,
    inference: inferenceModels,
    llama: llamaModels,
    lmstudio: lmstudioModels,
    mistral: mistralModels,
    modelscope: modelscopeModels,
    moonshotai: moonshotaiModels,
    "moonshotai-cn": moonshotai_cnModels,
    morph: morphModels,
    nvidia: nvidiaModels,
    openai: openaiModels,
    opencode: opencodeModels,
    openrouter: openrouterModels,
    perplexity: perplexityModels,
    requesty: requestyModels,
    submodel: submodelModels,
    synthetic: syntheticModels,
    togetherai: togetheraiModels,
    upstage: upstageModels,
    v0: v0Models,
    venice: veniceModels,
    vercel: vercelModels,
    wandb: wandbModels,
    xai: xaiModels,
    zai: zaiModels,
    "zai-coding-plan": zai_coding_planModels,
    zhipuai: zhipuaiModels,
};
export function getModels() {
    return providersCatalog;
}
//# sourceMappingURL=index.js.map